'use client';
import { useSignInState, type SignInFormProps } from './use-sign-in-state';
import { createSignInCredentialActions } from './sign-in-credential-actions';
import { createSignInVerificationActions } from './sign-in-verification-actions';
export function useSignInController(props: SignInFormProps) {
  const state = useSignInState(props);
  const actions = {
    ...createSignInCredentialActions(state),
    ...createSignInVerificationActions(state),
  };

  return { ...state, ...actions };
}
